export default "__VITE_ASSET__Dw8XZsYu__"